<div *ngFor="let notification of notifications" class="notification-container" [class]="notification.type.toLowerCase()">
    <!-- todo: change the flow openNotificationLink($event, notification) shouldn't be called on any click -->
    <div class="notification-header" (click)="openNotificationLink($event, notification)">
        <ds-toast
            [theme]="$any(notification.type.toLowerCase())"
            [header]="notification | notificationToastHeader"
            [content]="notification.message"
            (closeClick)="dismiss($event, notification)"
        ></ds-toast>
    </div>
</div>
